import type { JObject } from '../types';

export interface ContractValidationSchema extends JObject {
  type: 'object';
}

export const CONTRACT_FIELDS: Record<string, string> = {
  carrierKey: 'carrier',
  customerId: 'customer',
  customerLaneKey: 'customerLaneId',
  primaryDocumentId: 'primaryDocumentKey',
  trailerKey: 'trailer',
};

export const CONTRACT_LABELS: Record<string, string | Record<string, string>> = {
  approvedBy: 'Approved By',
  approvedOn: 'Approved On',
  cargoType: 'Cargo Type',
  carrier: 'Transportation Provider',
  customerLaneId: 'Customer Lane',
  effectiveFrom: 'Effective From',
  effectiveTo: 'Effective To',
  name: 'Contract Name',
  pricingBasis: 'Pricing Basis',
  pricingCategory: 'Pricing Category',
  pricingType: 'Pricing Type',
  primaryDocumentKey: 'Primary Document',
  serviceLayer: 'Service Layer',
  status: 'Contract Status',
  supplierDiversity: 'Supplier Diversity',
  trailer: 'Equipment Type',
  transportationMode: 'Transportation Mode',
  uniqueName: 'Contract Number',
};
